// Observe [data-add-prize-draw="1"]:
// use MutationObserver to observe the element
// if classes quiz--complete quiz--evaluated are added, add the prize draw formular
// example: <div class="quiz quiz--complete quiz--evaluated" data-method="POST" data-save="/api/quizes/saveQuizParticipation/" data-source="/api/quizes/getQuiz/" data-quiz-id="1" data-add-prize-draw="1">

const PRIZE_DRAW_SELECTOR = '[data-add-prize-draw="1"]';
const TYPE_NUM_LOAD_FORMULAR = 1779087603;
const TYPE_NUM_SUBMIT_FORMULAR_DATA = 1779096965;

const observedRoots = new WeakSet();

/**
 * @param {Element} el
 */
function prizeDrawQuizReady(el) {
	return (
		el.matches(PRIZE_DRAW_SELECTOR) &&
		el.classList.contains("quiz--complete") &&
		el.classList.contains("quiz--evaluated")
	);
}

/**
 * @param {Element} el
 */
function onPrizeDrawQuizClassChange(el) {
	if (!prizeDrawQuizReady(el)) {
		return;
	}

	const formData = new FormData();
	formData.append("quizId", el.dataset.quizId);

	fetch("/?type=" + TYPE_NUM_LOAD_FORMULAR, {
		method: "POST",
		body: formData,
	})
		.then((response) => response.text())
		.then((html) => {
			const div = document.createElement("div");
			div.classList.add("quiz__prize-draw-formular");
			div.innerHTML = html;
			el.appendChild(div);
			el.querySelector(".quiz__footnotes")?.remove();
			onPrizeDrawFormularSubmit(div);
		});
}

/**
 * @param {Element} el
 */
function onPrizeDrawFormularSubmit(el) {
	const form = el.querySelector(".form--prize-draw");
	if (!form) {
		return;
	}
	form.addEventListener("submit", (event) => {
		event.preventDefault();
		const formData = new FormData(form);
		formData.append("submitData", "1");
		fetch("/?type=" + TYPE_NUM_SUBMIT_FORMULAR_DATA, {
			method: "POST",
			body: formData,
		})
			.then((response) => response.text())
			.then((html) => {
				el.innerHTML = html;
				onPrizeDrawFormularSubmit(el);
			});
	});
}

/**
 * @param {Element} el
 */
function attachPrizeDrawObserver(el) {
	if (observedRoots.has(el)) {
		return;
	}
	observedRoots.add(el);

	// Quiz may already be finished when this script runs
	onPrizeDrawQuizClassChange(el);

	const observer = new MutationObserver((mutations) => {
		for (const mutation of mutations) {
			if (
				mutation.type !== "attributes" ||
				mutation.attributeName !== "class"
			) {
				continue;
			}
			const target = mutation.target;
			if (
				!(target instanceof Element) ||
				!target.matches(PRIZE_DRAW_SELECTOR)
			) {
				continue;
			}
			console.log(mutation);
			onPrizeDrawQuizClassChange(target);
		}
	});

	observer.observe(el, {
		attributes: true,
		attributeFilter: ["class"],
	});
}

/**
 * @param {ParentNode} root
 */
function attachObserversUnder(root) {
	if (root instanceof Element && root.matches(PRIZE_DRAW_SELECTOR)) {
		attachPrizeDrawObserver(root);
	}
	root.querySelectorAll(PRIZE_DRAW_SELECTOR).forEach(attachPrizeDrawObserver);
}

attachObserversUnder(document.body);

// Quizzes injected after load (e.g. AJAX): pick up new roots
const treeObserver = new MutationObserver((records) => {
	for (const record of records) {
		for (const node of record.addedNodes) {
			if (node.nodeType !== Node.ELEMENT_NODE) {
				continue;
			}
			attachObserversUnder(node);
		}
	}
});

treeObserver.observe(document.body, {
	childList: true,
	subtree: true,
});

// if data-attributes added, load the prize draw formular
// if data-attributes removed, remove the prize draw formular

const prizeDrawElements = document.querySelectorAll(PRIZE_DRAW_SELECTOR);

prizeDrawElements.forEach((element) => {
	const dataAttributes = element.dataset;
	console.log(dataAttributes);
});
